// Library
import React, { useState } from 'react';
// TimePicker from 'react-time-picker' without styles;
import TimePicker from 'react-time-picker';

type Value = string | null;

// CSS Style for this module
import styles from './TimeField.module.scss';

/**
 * Interface for TimeFieldProps props
 */
interface TimeFieldProps {
	/**
	 * Custom styles of the field
	 */
	customStyles?: string;
	/**
	 * Default value for edit mode
	 */
	defaultValue?: string;
	/**
	 * onChange function for keeping track field value
	 * debounce is built in
	 */
	handleChange?: (value: string) => void;
	/**
	 * Msg to be displayed when the status is error
	 */
	errorMsg?: string;
	/**
	 * Boolean for determining whether this is a required field
	 */
	status?: 'valid' | 'error';
	/** Element identifier selector for test */
	testId?: string;
}

export function TimeField({
	customStyles,
	defaultValue,
	errorMsg = 'Please enter hours and minutes in 24hr time',
	status = 'valid',
	handleChange = () => {
		return;
	},
	testId,
}: TimeFieldProps) {
	const [time, setTime] = useState(defaultValue);

	const onChangeValue = (value: Value) => {
		setTime(value ? value : '');
		handleChange(value ? value : '');
	};

	return (
		<div className={[styles.container, customStyles].join(' ')}>
			<TimePicker
				onChange={onChangeValue}
				value={time}
				hourPlaceholder="hh"
				minutePlaceholder="mm"
				format="HH:mm"
				clockIcon={null}
				clearIcon={null}
				className={[styles['timepicker'], styles[`timepicker-${status}`]].join(' ')}
				data-testid={testId}
			/>
			<p
				className={[styles['error-msg'], status !== 'error' && styles['error-msg-hide']].join(' ')}
			>
				{errorMsg}
			</p>
		</div>
	);
}
